import { render, staticRenderFns } from "./users.vue?vue&type=template&id=0634d390&scoped=true&"
import script from "./users.ts?vue&type=script&lang=ts&"
export * from "./users.ts?vue&type=script&lang=ts&"
import style0 from "./users.scss?vue&type=style&index=0&id=0634d390&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0634d390",
  null
  
)

export default component.exports